import { render, staticRenderFns } from "./FranchiseFormView.vue?vue&type=template&id=0473d76e&scoped=true"
import script from "./FranchiseFormView.vue?vue&type=script&lang=ts"
export * from "./FranchiseFormView.vue?vue&type=script&lang=ts"
import style0 from "./FranchiseFormView.vue?vue&type=style&index=0&id=0473d76e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0473d76e",
  null
  
)

export default component.exports